import React, { Component } from 'react';
import Mapbox from '../utils/Mapbox';

class SearchList extends Component{
    constructor(props){
       super(props);
       this.resultCount = null;
    }

    componentWillReceiveProps(props){
        this.resultCount = props.fData.length;
    }
    
    close(){
        this.props.field.value = '';
        this.props.filter([]);
        this.props.map.setLayoutProperty('uaeu', 'visibility', 'none');
    }
    clickHandler(e){
        this.props.map.setFilter('uaeu', ['in', 'id'].concat(e.properties.id));
        this.props.map.flyTo({
            center: e.geometry.coordinates,
            speed: 0.5,
            zoom: 15.6
        });
            
        this.props.filter([]);
        this.props.field.value = e.properties.title;
        
        this.props.map.flyTo({
            center: [55.67900, 24.19760],
            speed: 0.2,
            zoom: 15.2
        });     

        
        Mapbox.popUp(e, this.props.map);
        
    }

    render(){

        let searchHeader =  <div className="map-search-header">
            <div className="map-search-header-block">{this.resultCount} Results</div>
            <div className="map-search-header-close" onClick={this.close.bind(this)} data-close>x</div>
        </div>;


        
        let searchResult = this.props.fData.map((data) => {
            return <a key={data.properties.id} data-id={data.properties.id} className="map-search-item" onClick={this.clickHandler.bind(this, data)}> 
                        <div className="map-search-item-title">{data.properties.title}</div>
                        <div className="map-search-item-type">{data.properties.type}</div>
                    </a>;
            
        });

        return(
            <div id="map-search-list">
                {searchResult.length > 0 ? searchHeader : ''}
                <div id="map-search-item-wrap">
                    {searchResult}
                </div>
            </div>
        );
    }
}
export default SearchList;


// WEBPACK FOOTER //
// ./src/components/SearchList.js